import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import { BasisTypeBF } from '../../models'
import type { RootState } from '../store'
import { CustomerTypes } from '@raskrask-dk/raskrask-utils'

const initialState = {
  customerTypes: ['Private', 'Company'] as CustomerTypes,
  basisTypes: [] as BasisTypeBF[],
}

export const basisTypesSettings = createSlice({
  name: 'basisTypesSettings',
  initialState,
  reducers: {
    setCustomerTypes: (state, action: PayloadAction<CustomerTypes>) => {
      state.customerTypes = action.payload
    },
  },
})

export const getCustomerTypes = (state: RootState): CustomerTypes =>
  state.basisTypesSettings.customerTypes

export default basisTypesSettings.reducer
